import { render, staticRenderFns } from "./DollarInput.vue?vue&type=template&id=ed21ddd2&scoped=true&"
import script from "./DollarInput.vue?vue&type=script&lang=js&"
export * from "./DollarInput.vue?vue&type=script&lang=js&"
import style0 from "./DollarInput.vue?vue&type=style&index=0&id=ed21ddd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21ddd2",
  null
  
)

export default component.exports